export default "/images/6eb477b3f027937f9d36a2d731c85bc8.avif";